"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_textarea_autosize_1 = __importDefault(require("react-textarea-autosize"));
var md5_1 = __importDefault(require("md5"));
var sharer_1 = __importDefault(require("../shared/sharer"));
var sanitize_html_1 = __importDefault(require("sanitize-html"));
var data_service_1 = __importDefault(require("../../services/data.service"));
var date_fns_1 = require("date-fns");
var react_transition_group_1 = require("react-transition-group");
var helpers_1 = require("../../shared/helpers");
var auth_service_1 = __importDefault(require("../../services/auth.service"));
var lang_service_1 = __importDefault(require("../../services/lang.service"));
var defaultLocalAvatar = (0, md5_1.default)((0, helpers_1.getRandomEmail)());
var baseComment = {
    author: '',
    email: '',
    content: '',
    pubDate: '',
};
var EpisodeComments = (function (_super) {
    __extends(EpisodeComments, _super);
    function EpisodeComments() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            newComment: __assign({}, baseComment),
            comments: [],
            isSaving: false,
            localAvatar: defaultLocalAvatar,
            enableAdminOptions: auth_service_1.default.isSignedInAsAdmin(),
            currentLoggedUser: auth_service_1.default.getCurrentUser(),
            unsubscribeFromComments: function () { return null; },
        };
        _this.handleChange = function (evt) {
            var target = evt.target;
            if (target && target.name)
                _this.setState(function (prevState) {
                    var _a;
                    return ({
                        newComment: __assign(__assign({}, prevState.newComment), (_a = {}, _a[target.name] = target.value, _a)),
                    });
                });
        };
        _this.updateLocalAvatar = function () {
            var _a = _this.state.newComment, email = _a.email, author = _a.author;
            if (!email.trim().length && !author.trim().length)
                return;
            var newLocalAvatar = email.length ? (0, md5_1.default)(email) : (0, md5_1.default)(author);
            _this.setState({
                localAvatar: newLocalAvatar,
            });
        };
        _this.generateAvatarSrc = function (_a) {
            var email = _a.email, author = _a.author;
            if (!email.trim().length && !author.trim().length)
                return defaultLocalAvatar;
            var avatar = email.length ? (0, md5_1.default)(email) : (0, md5_1.default)(author);
            return "https://www.gravatar.com/avatar/".concat(avatar, ".jpg?s=140&d=wavatar");
        };
        _this.submitFormHandler = function (evt) {
            evt.preventDefault();
            _this.setState({ isSaving: true }, function () { return __awaiter(_this, void 0, void 0, function () {
                var newComment, _a, comic, episode, newCommentId;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            newComment = this.state.newComment;
                            _a = this.props, comic = _a.comic, episode = _a.episode;
                            return [4, data_service_1.default.addComment(comic.id, episode.id, newComment)];
                        case 1:
                            newCommentId = _b.sent();
                            if (newCommentId) {
                                window.localStorage.setItem('userData', JSON.stringify({
                                    author: newComment.author,
                                    email: newComment.email,
                                }));
                                this.setState(function (prevState) { return ({
                                    newComment: __assign(__assign({}, prevState.newComment), { content: '' }),
                                    isSaving: false,
                                }); });
                            }
                            return [2];
                    }
                });
            }); });
        };
        _this.isCommentValid = function () {
            var _a = _this.state, newComment = _a.newComment, isSaving = _a.isSaving, enableAdminOptions = _a.enableAdminOptions;
            if (isSaving)
                return false;
            if (enableAdminOptions)
                return true;
            var trimmedAuthor = newComment.author.trim();
            var trimmedContent = newComment.content.trim();
            var trimmedEmail = newComment.email.trim();
            return (trimmedAuthor.length &&
                trimmedContent.length &&
                !(trimmedAuthor.toLowerCase() === 'albert') &&
                !(trimmedEmail.toLowerCase() === 'albertodlh@gmail.com'));
        };
        _this.renderEmptyState = function () {
            var getLabel = lang_service_1.default.getLabel;
            return (react_1.default.createElement("div", { className: "episode-comments__empty-state" },
                react_1.default.createElement("span", { className: "episode-comments__empty-state-icon icon-comments-2" }),
                react_1.default.createElement("h2", { className: "episode-comments__empty-state-title" }, getLabel('noCommentsTitle')),
                react_1.default.createElement("p", null, getLabel('noCommentsContent'))));
        };
        _this.renderComments = function (comments) {
            return (react_1.default.createElement(react_transition_group_1.TransitionGroup, { enter: true }, comments.map(function (comment) { return (react_1.default.createElement(react_transition_group_1.CSSTransition, { key: comment.id, timeout: 1000, classNames: "comment" },
                react_1.default.createElement("div", { className: "comment" },
                    react_1.default.createElement("img", { className: "comment__img", src: _this.generateAvatarSrc(comment) }),
                    react_1.default.createElement("div", { className: "comment__content-container" },
                        react_1.default.createElement("h4", { className: "comment__header" },
                            comment.author,
                            react_1.default.createElement("span", { className: "comment__pub-date" }, comment.pubDate &&
                                (0, date_fns_1.formatDistanceToNow)(new Date(comment.pubDate), { addSuffix: true }))),
                        react_1.default.createElement("div", { className: "comment__content", dangerouslySetInnerHTML: _this.sanitizeComment(comment.content) }))))); })));
        };
        return _this;
    }
    EpisodeComments.prototype.subscribeToEpisodeComments = function (resetCommentForm) {
        var _this = this;
        if (resetCommentForm === void 0) { resetCommentForm = false; }
        var _a = this.props, comic = _a.comic, episode = _a.episode;
        this.setState({
            unsubscribeFromComments: data_service_1.default.subscribeToComments(comic.id, episode.id, function (comments) {
                return _this.setState({ comments: comments });
            }),
        }, function () {
            if (resetCommentForm) {
                var userDataStr = window.localStorage.getItem('userData');
                if (userDataStr) {
                    var userData_1 = JSON.parse(userDataStr);
                    _this.setState(function (prevState) { return ({
                        newComment: __assign(__assign({}, prevState.newComment), { author: userData_1.author, email: userData_1.email }),
                    }); }, _this.updateLocalAvatar);
                }
            }
        });
    };
    EpisodeComments.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.subscribeToEpisodeComments(true);
                return [2];
            });
        });
    };
    EpisodeComments.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            var prevEpisode, episode;
            return __generator(this, function (_a) {
                prevEpisode = prevProps.episode;
                episode = this.props.episode;
                if (prevEpisode.id !== episode.id) {
                    this.state.unsubscribeFromComments();
                    this.subscribeToEpisodeComments(false);
                }
                return [2];
            });
        });
    };
    EpisodeComments.prototype.componentWillUnmount = function () {
        this.state.unsubscribeFromComments();
    };
    EpisodeComments.prototype.sanitizeComment = function (content) {
        var styledContent = content
            .replace(/(?:\r\n|\r|\n)/g, '<br />')
            .replace(/<br \/><br \/>/g, '</p><p>');
        styledContent = "<p>".concat(styledContent, "</p>");
        return {
            __html: (0, sanitize_html_1.default)(styledContent, {
                allowedTags: ['p', 'br', 'b', 'i', 'em', 'strong'],
                disallowedTagsMode: 'recursiveEscape',
            }),
        };
    };
    EpisodeComments.prototype.render = function () {
        var _a = this.state, comments = _a.comments, newComment = _a.newComment, enableAdminOptions = _a.enableAdminOptions, localAvatar = _a.localAvatar, currentLoggedUser = _a.currentLoggedUser;
        var _b = this.props, comic = _b.comic, episode = _b.episode;
        var getLabel = lang_service_1.default.getLabel;
        return (react_1.default.createElement("div", { className: "episode-comments" },
            react_1.default.createElement("h1", { className: "episode-comments__title" }, getLabel('commentTitle')),
            react_1.default.createElement(sharer_1.default, { href: comic.isOneShot ? "/".concat(comic.slug, "/") : "/".concat(comic.slug, "/episodes/").concat(episode.slug, "/") }),
            react_1.default.createElement("div", { className: "episode-comments__form-container" },
                enableAdminOptions && react_1.default.createElement("p", { className: "episode-comments__admin-msg" },
                    "You have admin superpowers, ",
                    currentLoggedUser.displayName),
                react_1.default.createElement("img", { className: "episode-comments__form-img", src: "https://www.gravatar.com/avatar/".concat(localAvatar, ".jpg?s=140&d=wavatar") }),
                react_1.default.createElement("form", { className: "episode-comments__form", onSubmit: this.submitFormHandler },
                    react_1.default.createElement("div", { className: "field-group one-half" },
                        react_1.default.createElement("div", { className: "form-element" },
                            react_1.default.createElement("label", { className: "hidden", htmlFor: "comment-author" }, "Author"),
                            react_1.default.createElement("input", { placeholder: getLabel('authorPhd'), id: "comment-author", type: "text", name: "author", onChange: this.handleChange, onBlur: this.updateLocalAvatar, value: newComment.author }),
                            !enableAdminOptions && newComment.author.trim().toLowerCase() === 'albert' && (react_1.default.createElement("p", { className: "form-element__hint color-error" }, "You can't use that name :)"))),
                        react_1.default.createElement("div", { className: "form-element" },
                            react_1.default.createElement("label", { className: "hidden", htmlFor: "comment-email" }, "Email"),
                            react_1.default.createElement("input", { placeholder: getLabel('emailPhd'), id: "comment-email", type: "text", name: "email", onChange: this.handleChange, onBlur: this.updateLocalAvatar, value: newComment.email }),
                            !enableAdminOptions &&
                                newComment.email.trim().toLowerCase() === 'albertodlh@gmail.com' && (react_1.default.createElement("p", { className: "form-element__hint color-error" }, "You can't use that email :)")))),
                    react_1.default.createElement("div", { className: "form-element" },
                        react_1.default.createElement("label", { className: "hidden", htmlFor: "comment-content" }, "Content"),
                        react_1.default.createElement(react_textarea_autosize_1.default, { maxRows: 10, minRows: 1, placeholder: getLabel('contentPhd'), id: "comment-content", onChange: this.handleChange, name: "content", value: newComment.content })),
                    react_1.default.createElement("div", { className: "form-actions text-end" },
                        react_1.default.createElement("button", { className: "btn", disabled: !this.isCommentValid(), type: "submit" }, getLabel('commentBtn'))))),
            comments.length ? this.renderComments(comments) : this.renderEmptyState()));
    };
    return EpisodeComments;
}(react_1.Component));
exports.default = (0, react_router_dom_1.withRouter)(EpisodeComments);
